import { useEffect, useState } from 'react';
import logoMark from '../../assets/images/logo-mark.png';
import './PageLoader.css';

/**
 * Gates the page on fonts and images only — videos carry their own spinner, so
 * a 10 MB download doesn't hold up something the visitor could already read.
 */
export default function PageLoader() {
  const [done, setDone] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const finish = () => { if (!cancelled) setDone(true); };

    const imgs = Array.from(document.images).filter((i) => !i.complete);
    const jobs = imgs.map((i) => new Promise((r) => {
      i.addEventListener('load', r, { once: true });
      i.addEventListener('error', r, { once: true });
    }));
    if (document.fonts && document.fonts.ready) jobs.push(document.fonts.ready);

    Promise.all(jobs).then(() => setTimeout(finish, 120));
    const bail = setTimeout(finish, 6000);
    return () => { cancelled = true; clearTimeout(bail); };
  }, []);

  if (done) return null;

  return (
    <div className="rw-loader">
      <img src={logoMark} alt="Riftworks" className="rw-loader__mark" />
      <div className="rw-loader__row">
        <span className="rw-spinner" />
        <span className="rw-spinner__label">Loading</span>
      </div>
    </div>
  );
}
